import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import EventsScreen from '../../Event/EventsScreen';
import DocumentsScreen from '../../DocumentsScreen';
import ProfilesScreen from '../../ProfilesScreen';
import OrganizersScreen from '../../Organizer/OrganizersScreen';
import AppLayout from '../AppLayout';
import LogIn from '../../LogIn';
import ConfirmReceipt from '../../ConfirmReceipt';
import InvoiceReceipt from '../../InvoiceReceipt';
import RequireToken from '../RequireAuth';
import OrganizerTransactionListScreen from '../../Organizer/OrganizerTransactionListScreen';
import EventTransactionListScreen from '../../Event/EventTransactionListScreen';
import OrganizerRequestListScreen from '../../Organizer/OrganizerRequestListScreen';
import TransactionListScreen from '../../Transaction/TransactionListScreen';

const Root: React.FC = () => {
  return (<>
    <AppLayout>
      <Routes>
        <Route path="/login" element={<LogIn />} />
        <Route path="/confirm-receipt" element={<ConfirmReceipt/>} />
        <Route path="/invoice-receipt" element={<InvoiceReceipt/>} />
        <Route element={<RequireToken />}>
          <Route path="/" element={<Navigate to="/events/all" replace />} />
          <Route path="/events/:type" element={<EventsScreen />} />
          <Route path="/events/:id/transaction/list/:type" element={<EventTransactionListScreen />} />
          <Route path="/profiles" element={<ProfilesScreen/>} />
          <Route path="/transactions/:type" element={<TransactionListScreen/>} />
          <Route path="/organizers/:type" element={<OrganizersScreen/>} />
          <Route path="/organizers/request/list" element={<OrganizerRequestListScreen/>} />
          <Route path="/organizers/:id/transaction/list/:type" element={<OrganizerTransactionListScreen />} />
          <Route path="/documents" element={<DocumentsScreen/>} />
        </Route>
        
      </Routes>
    </AppLayout>
</>
  );
};

export default Root;
